export interface CanLeaveGroupOptions {
  group?: {
    university?: {
      slug: string
    }
    universityCourse?: {
      slug: string
    }
  }
}

/**
 * This is a helper function that determines if a user can leave a group.
 *
 *! Ideally we would have these access rules in the GraphQL schema, but this is
 *! a brute force way of doing it for now until we can figure out the exact
 *! access rules for each group, and how they can be configurable.
 *
 * @param options Options used for determining if a user can leave a group
 * @returns True if the user can leave the group, otherwise false
 */
export const canLeaveGroup = (options: CanLeaveGroupOptions): boolean => {
  // Only if we have a group can we leave it
  if (!options.group) {
    return false
  }

  // Cannot leave university groups
  if (!!options.group.university) {
    return false
  }

  // Cannot leave university course groups
  if (!!options.group.universityCourse) {
    return false
  }

  // Okay, the user can leave the group
  return true
}
